/** Apply brightness offset to a single channel value. brightness: -100 to 100 */
export function applyBrightness(value: number, brightness: number): number {
  return value + (brightness * 255) / 100;
}
